module.exports = __webpack_public_path__ + "static/media/acloudguru.2e2002d9.png";